import Vue from 'vue'

import toolBar from './ToolBar.vue'
import helpHint from './HelpHint.vue'

// import deleleHint from './DeleleHint.vue'
import breadcrumb from './Breadcrumb.vue'
import paging from './Paging.vue'


import kcButtonDel from './kcButton/kcButtonDel.vue'
import kcButtonRefresh from './kcButton/kcButtonRefresh.vue'
import kcButtonAdd from './kcButton/kcButtonAdd.vue'
import kcButtonFind from './kcButton/kcButtonFind.vue'
import kcButtonDelMini from './kcButton/kcButtonDelMini.vue'
import kcButtonEditMini from './kcButton/kcButtonEditMini.vue'
import kcButtonFindMini from './kcButton/kcButtonFindMini.vue'
import kcButtonMini from './kcButton/kcButtonMini.vue'


import uploadFile from './upload/UploadFile.vue'
import uploadImg from './upload/UploadImg.vue'
import uploadImgList from './upload/UploadImgList.vue'

import KcStatusTag from './KcStatusTag.vue'
import KcTags from './KcTags.vue'

import kcStatusYnEn from './status/kcStatusYnEn.vue'
import kcStatusQT from './status/kcStatusQT.vue'

// import kcTable from './kcTable/kcTable.vue'
// import kcTable from 'vueTemplet/kcTable.vue'
import kcStatusStop from './status/kcStatusStop.vue'
import imgView from './imgView.vue'
import sysType from './sysType.vue'
import sysRate from './sysRate.vue'
import sysTypeList from './sysTypeList.vue'
import aMapClick from './aMapClick.vue'
import sysMoney from './sysMoney.vue'

export default (Vue) => {
    // Vue.component("kcTable",kcTable);
    Vue.component("KcTags", KcTags);
    Vue.component("KcStatusTag", KcStatusTag);
    Vue.component("toolBar", toolBar);
    Vue.component("helpHint", helpHint);
    Vue.component("breadcrumb", breadcrumb);
    Vue.component("paging", paging);
    Vue.component("toolBar", toolBar);
    Vue.component("kcButtonAdd", kcButtonAdd);
    Vue.component("kcButtonRefresh", kcButtonRefresh);
    Vue.component("kcButtonDel", kcButtonDel);
    Vue.component("kcButtonFind", kcButtonFind);
    Vue.component("kcButtonDelMini", kcButtonDelMini);
    Vue.component("kcButtonEditMini", kcButtonEditMini);
    Vue.component("kcButtonFindMini", kcButtonFindMini);
    Vue.component("kcButtonMini", kcButtonMini);


    Vue.component("uploadFile", uploadFile);
    Vue.component("uploadImg", uploadImg);
    Vue.component("uploadImgList", uploadImgList);
    // Vue.component("kcTable",kcTable);

    Vue.component("kcStatusYnEn", kcStatusYnEn);
    Vue.component("kcStatusQT", kcStatusQT);
    Vue.component("kcStatusStop", kcStatusStop);
    Vue.component("imgView", imgView);
    Vue.component("sysType", sysType);
    Vue.component("sysTypeList", sysTypeList);
    Vue.component("aMapClick", aMapClick);
    Vue.component("sysMoney", sysMoney);
    Vue.component("sysRate", sysRate);
}



// WEBPACK FOOTER //
// ./src/kc/keTemp/_keTemp.js